export default __webpack_public_path__ + "static/media/team_value_words.fe532ddc.svg";